import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Container, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Button, Snackbar, Alert } from '@mui/material';
import Layout from '../components/Layout/Layout';
import axios from '../api/axiosConfig';

const fetchRoles = async () => { const { data } = await axios.get('/roles'); return data; };
const updatePermissions = async ({ id, permissions }) => axios.put(`/roles/${id}/permissions`, { permissions });

const allPermissions = ['dashboard', 'calendar', 'vehicles', 'workorders', 'devices', 'clients', 'users', 'roles', 'profile', 'settings'];

const RolesPage = () => {
  const { data: roles, isLoading } = useQuery({ queryKey: ['roles'], queryFn: fetchRoles });
  const [localRoles, setLocalRoles] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: updatePermissions,
    onSuccess: () => { queryClient.invalidateQueries(['roles']); setSnackbar({ open: true, message: 'Permissions updated', severity: 'success' }); },
    onError: () => setSnackbar({ open: true, message: 'Update failed', severity: 'error' })
  });

  React.useEffect(() => {
    if (roles) setLocalRoles(roles);
  }, [roles]);

  const togglePermission = (roleId, perm) => {
    setLocalRoles(prev => prev.map(r => r._id === roleId ? { ...r, permissions: r.permissions.includes(perm) ? r.permissions.filter(p => p !== perm) : [...r.permissions, perm] } : r));
  };

  const saveRole = (role) => {
    mutation.mutate({ id: role._id, permissions: role.permissions });
  };

  if (isLoading) return <Layout><Typography>Loading...</Typography></Layout>;

  return (
    <Layout>
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>Role Permissions</Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow><TableCell>Role</TableCell>{allPermissions.map(p => <TableCell key={p}>{p}</TableCell>)}<TableCell>Actions</TableCell></TableRow>
            </TableHead>
            <TableBody>
              {localRoles.map(role => (
                <TableRow key={role._id}>
                  <TableCell>{role.name}</TableCell>
                  {allPermissions.map(perm => (
                    <TableCell key={perm}><Checkbox checked={role.permissions.includes(perm)} onChange={() => togglePermission(role._id, perm)} /></TableCell>
                  ))}
                  <TableCell><Button variant="outlined" onClick={() => saveRole(role)}>Save</Button></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
          <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
        </Snackbar>
      </Container>
    </Layout>
  );
};

export default RolesPage;